import URI from 'urijs';
import { wrapFunc, AesEncrypt } from '../../util/js';
import { CB_STATUS, cFetch } from '../../util/fetch';
import {
  PATH_API_RSTPWD,
  PATH_API_USER,
  PATH_API_VERICODE,
} from '../../config';
import { getDomain } from '../../util/url';
import { errCB } from './auth';

export const actGetUser = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'USER_GET_DOING',
  });
  const email = AesEncrypt(data.email);
  // const url = `${getDomain() + PATH_API_USER + data.email}/`;
  const url = `${getDomain() + PATH_API_USER + email}/`;

  return cFetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        dispatch({
          type: 'USER_GET_DONE',
          payload: {
            email: j.payload.email || data.email,
            firstName: j.payload.firstName || 'Anonymous',
            lastName: j.payload.lastName || '',
            forceChangePassword: j.payload.forceChangePassword || false,
          },
        });
      } else {
        throw j;
      }
      if (cb) cb({ status: CB_STATUS.SUCCESS });
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'USER_GET_ERR',
      });
      switch (err.status) {
        case 400:
          if (cb) cb({ status: CB_STATUS.INVALID });
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actGetUser');

export const actCreateUser = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'USER_CREATE_DOING',
  });
  const url = getDomain() + PATH_API_USER;
  const formData = new FormData();
  // formData.append('email', data.email);
  // formData.append('lastName', data.lastName);
  // formData.append('firstName', data.firstName);
  // formData.append('password', data.password);
  // formData.append('code', data.veriCode);

  formData.append('email', AesEncrypt(data.email));
  formData.append('lastName', AesEncrypt(data.lastName));
  formData.append('firstName', AesEncrypt(data.firstName));
  formData.append('password', AesEncrypt(data.password));
  formData.append('code', AesEncrypt(data.veriCode));

  return cFetch(url, {
    method: 'POST',
    headers: {
      'Accept-Language': data.lang || 'en',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 201) {
        dispatch({
          type: 'USER_CREATE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'USER_CREATE_ERR',
      });
      switch (err.status) {
        case 400:
          if (err.payload.detail === 'Invalid verification code.') {
            if (cb) cb({ status: CB_STATUS.INVALID });
            break;
          } else if (err.payload.email !== undefined) {
            if (
              err.payload.email[0]
              === 'my user with this email address already exists.'
            ) {
              if (cb) cb({ status: CB_STATUS.EXIST });
              break;
            }
          }
          if (cb) cb({ status: CB_STATUS.OTHER });
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actCreateUser');

export const actUpdateUser = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'USER_UPDATE_DOING',
  });

  // const url = `${getDomain() + PATH_API_USER + data.email}/`;
  const url = `${getDomain() + PATH_API_USER + AesEncrypt(data.email)}/`;
  const formData = new FormData();
  if (data.current_password && data.password) {
    // formData.append('current_password', data.current_password);
    // formData.append('password', data.password);
    formData.append('current_password', AesEncrypt(data.current_password));
    formData.append('password', AesEncrypt(data.password));
  }
  if (data.lastName && data.firstName) {
    // formData.append('lastName', data.lastName);
    // formData.append('firstName', data.firstName);
    formData.append('lastName', AesEncrypt(data.lastName));
    formData.append('firstName', AesEncrypt(data.firstName));
  }

  return cFetch(url, {
    method: 'PATCH',
    body: formData,
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        dispatch({
          type: 'USER_UPDATE_DONE',
        });
        if (cb) {
          cb({ status: CB_STATUS.SUCCESS });
        }
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'USER_UPDATE_ERR',
      });
      switch (err.status) {
        case 400:
          if (cb) cb({ status: CB_STATUS.INVALID });
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actUpdateUser');

export const actRstPwd = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'USER_RSTPWD_DOING',
  });
  const urlQuery = {
    email: AesEncrypt(data.email),
  };
  const url = URI(getDomain() + PATH_API_RSTPWD)
    .query(urlQuery)
    .toString();

  return cFetch(url, {
    method: 'POST',
    headers: {
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 204) {
        dispatch({
          type: 'USER_RSTPWD_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'USER_RSTPWD_ERR',
      });
      if (!err) {
        if (cb) {
          cb({ status: CB_STATUS.INVALID });
        }
      }
      switch (err.status) {
        case 400:
          if (cb) {
            if (err.payload && err.payload.detail === 'You can only reset the password 5 times a day.') {
              cb({ status: CB_STATUS.RESETLIMIT });
            } else {
              cb({ status: CB_STATUS.INVALID });
            }
          }
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actRstPwd');

export const actGetVariCode = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'USER_GETVARICODE_DOING',
  });

  const url = getDomain() + PATH_API_VERICODE;
  const formData = new FormData();
  if (data.lastName) {
    formData.append('lastName', AesEncrypt(data.lastName));
  }
  formData.append('email', AesEncrypt(data.email));

  return cFetch(url, {
    method: 'POST',
    headers: {
      'Accept-Language': data.lang || 'en',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 204) {
        dispatch({
          type: 'USER_GETVARICODE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'USER_GETVARICODE_ERR',
      });
      switch (err.status) {
        case 400:
          if (err.payload[0] === 'Existed email.') {
            if (cb) cb({ status: CB_STATUS.EXIST });
            break;
          }
          if (cb) cb({ status: CB_STATUS.OTHER });
          break;
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actGetVariCode');
